import React from "react";
import {AiOutlineLoading} from "react-icons/ai";

const ConfirmationModal = ({
                               visible,
                               title = "Sind Sie sicher?",
                               message = "Bitte bestätigen Sie Ihre Aktion.",
                               confirmText = "Ja",
                               cancelText = "Nein",
                               onConfirm,
                               onCancel,
                               loading = false,
                               fullWidthButtons = false,
                               icon = null,
                           }) => {
    if (!visible) return null;

    return (
        <div className="fixed inset-0 z-[60] flex items-center justify-center">
            <div
                className="absolute inset-0 bg-modalBackDropColor bg-opacity-60 durationbackdrop-blur-s-300"
                onClick={onCancel}
            ></div>
            <div className="relative z-10 bg-white rounded-xl shadow-2xl p-6 w-11/12 max-w-md transition-all duration-300">
                <div className="flex items-center justify-center gap-3 mb-4">
                    {icon && <div className="flex-shrink-0">{icon}</div>}
                    <h3 className="text-xl font-semibold text-gray-800">{title}</h3>
                </div>
                <p className="mb-6 text-gray-600">{message}</p>
                <div className={`flex ${fullWidthButtons ? 'gap-4' : 'justify-end space-x-4'}`}>
                    <button
                        className={`px-4 py-2 bg-whiteDark hover:bg-whiteDark text-grey rounded-md transition ${fullWidthButtons ? 'flex-1' : ''}`}
                        onClick={onCancel}
                    >
                        {cancelText}
                    </button>
                    <button
                        className={`px-4 py-2 rounded-md transition flex items-center justify-center ${
                            loading
                                ? 'bg-cancel cursor-not-allowed'
                                : 'bg-cancel hover:bg-red'
                        } text-white ${fullWidthButtons ? 'flex-1' : ''}`}
                        onClick={onConfirm}
                        disabled={loading}
                    >
                        {loading ? (
                            <AiOutlineLoading className="animate-spin mr-2" size={18} />
                        ) : null}
                        {confirmText}
                    </button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmationModal;
